// extracted by mini-css-extract-plugin
module.exports = {"page":"RequestPasswordResetPage_page__3kisD"};